import $ from 'jquery';
import mock from './mock';
import './notes/NotesData';
import './chat/Chatdata';
import './contacts/ContactsData';
import './email/EmailData';
import './ticket/TicketData';
import { handleSessionExpiry, isFleetNexisApiRequest } from '../constants/authSession';

mock.onAny().passThrough();

$.ajaxSetup({
  beforeSend: (jqXHR, settings) => {
    const requestUrl = settings?.url || '';
    if (!isFleetNexisApiRequest(requestUrl)) {
      return;
    }

    const token = localStorage.getItem('fleetnexis_token');

    if (token) {
      jqXHR.setRequestHeader('Authorization', `Bearer ${token}`);
    }
  },
});

$(document).ajaxError((_event, jqXHR, settings) => {
  if (jqXHR?.status === 401 && isFleetNexisApiRequest(settings?.url || '')) {
    handleSessionExpiry(settings?.url || '');
  }
});
